import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Text,
} from '@chakra-ui/react';
import Button from 'common/components/button';
import ContactCard from 'components/shared/contact-card';

const ContactSupportModal = ({
  buttonProps,
  modalHeader = 'Contact Support',
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        onClick={onOpen}
        {...buttonProps}
        title={buttonProps?.title || 'Contact Support'}
      />

      <Modal isOpen={isOpen} onClose={onClose} isCentered size='xl'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader className='font-medium text-xl'>{modalHeader}</ModalHeader>
          <ModalCloseButton />
          <ModalBody className='pt-0 pb-6 flex flex-col gap-4'>
            <Text className='text-base text-gray-500'>
              Visit our online FAQ or contact us via email or phone to get help.
            </Text>
            <ContactCard small border={false} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ContactSupportModal;
